<template>
  <div id="app" class="app app-header-fixed inno_app" :style="{background : themeColor}">
    <!--Header-->
    <Header v-if="!isAi" />
    <!--Aside-->
    
    <!--<Aside/>-->
    
    <!-- content -->
   
    <div id="content" class="app-content inno_content" role="main"> <!--  :style="screenHeight" -->
   <perfect-scrollbar>    
      <div class="app-content-body">
          <router-view />
      </div>
    </perfect-scrollbar>  
    </div>
    
    <!-- /content -->

    <Footer/>

  </div>
</template>
<style scoped>
.inno_app { --display:flex; --flex-direction:row; }
.inno_content { --flex:1; background:#fff; }
</style>

<script>
// @ is an alias to /src
import Header from '@/components/Header.vue'
import Aside from '@/components/Aside.vue'

const IS_AI = process.env.VUE_APP_WEB_DIR == '/ai';

export default {
  name: 'App',
  components: {
    Header,
    //Aside
  },
  data() {
    return {
      isAi: IS_AI
    }
  },
  async created(){
    if(!IS_AI) {
      this.getSchoolInfo();
    }
  },
  computed : {
    themeColor() {
      return this.$common.getUrl().themeColor;
    },
    headerHeight(){
      return this.$store.getters['others/headerHeight'];
    },
    /*
    screenHeight() {
      var screenHeight = window.innerHeight;//Math.min(window.screen.height, window.innerHeight);
      console.log("vvvvv this.headerHeight="+this.headerHeight+" window.screen.height==="+window.screen.height+ " window.innerHeight="+window.innerHeight);
      console.log("vvvvv height==="+(screenHeight - this.headerHeight));
      //return (screenHeight - this.headerHeight)+'px';
      return {top:`${this.headerHeight}px`, height:`calc(100% - ${this.headerHeight}px)`};
    },
    */
  },
  mounted(){
    let hh = this.headerHeight;
    this.$store.dispatch("others/setHeaderHeight", hh);

    const bd = document.querySelector(".app-content");
    bd.style.top = hh + 'px';
    bd.style.height = `calc(100% - ${hh}px)`;
  },
  methods: {

    /** 
     * 학교정보를 가져온다.
     * 
     * @method getSchoolInfo 
     * @param {String} uuid - 학교 고규 UUID, Admin의 경우에 UUID가 존재하지 않음
     */
    getSchoolInfo(){
      this.$store.dispatch('school/getSchoolInfo')
    }
  },
  watch: {
    headerHeight(newVal, oldVal) {
      //console.log(`##### Main.vue n:${newVal} o:${oldVal} #######`);
      const bd = document.querySelector(".app-content");
      bd.style.top = newVal + 'px';
      bd.style.height = `calc(100% - ${newVal}px)`;
    }
  }
}
</script>

